module.exports = __webpack_public_path__ + "img/text_record_07_close.f9a5b086.png";